import { render, staticRenderFns } from "./StudentClassInfo.vue?vue&type=template&id=af80aaa2&"
import script from "./StudentClassInfo.vue?vue&type=script&lang=js&"
export * from "./StudentClassInfo.vue?vue&type=script&lang=js&"
import style0 from "./StudentClassInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports